import styled, { keyframes } from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import { rem } from '@savgroup-front-common/primitive/helpers/units';

export const growUpKeyFrame = keyframes`
  0% { transform: scale(.8); }
  80% { transform: scale(1.25);}
  100% {transform: scale(1);}
`;

export const $CardContentHistoryWrapper = styled.div`
  flex: 0;
  display: flex;
  flex-direction: row;
  flex-flow: column;
  margin-top: ${spacing('xxs')};

  @media ${media.maxWidth.xs} {
    width: 70%;
    margin-left: calc(-1 * ${spacing('xl')});
  }
`;

export const $CardContentHistory = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const $CardContentHistoryPoint = styled.div<{
  active?: boolean;
  disabled?: boolean;
}>`
  z-index: 1;
  width: ${spacing(3.5)};
  height: ${spacing(3.5)};
  border-radius: 50%;
  animation: ${growUpKeyFrame} 0.5s linear;
  animation-delay: 0.5s;
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.colors.tertiary : theme.colors.primary};
  ${({ active, theme }) =>
    active
      ? `box-shadow: 0 0 ${spacing('sm')} ${theme.colors.primary};`
      : 'animation: none;'}
`;

export const $CardContentHistoryDashedLine = styled.div<{ isFirst: boolean }>`
  position: absolute;
  top: 50%;
  left: ${({ isFirst }) => (isFirst ? '58%' : '50%')};
  transform: translate(-50%, -50%);
  width: 70%;
  height: ${spacing('xxs')};
  background-image: ${({ theme }) => {
    const color = theme.colors.tertiary.replace('#', '');

    return `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23${color}' stroke-width='4' stroke-dasharray='6%2c 16' stroke-dashoffset='5' stroke-linecap='square'/%3e%3c/svg%3e")`;
  }};
`;

export const $CardContentHistoryPointContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
`;

export const $CardContentHistoryLegendWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-around;
`;

export const $CardContentHistoryLegend = styled.div<{
  disabled?: boolean;
  active?: boolean;
}>`
  width: ${rem(154)};
  margin: ${spacing('sm')} 0;
  display: flex;
  flex-direction: row;
  flex-flow: column;
  align-items: center;
  text-align: center;
  padding: 0 ${spacing('xs')};
  ${fontStyle('xxs')};
  font-weight: ${({ disabled }) =>
    disabled ? fontWeight('normal') : fontWeight('bold')};
  line-height: ${({ theme }) => theme.tw.font.size.sm};
  color: ${({ theme, disabled }) =>
    disabled ? theme.colors.tertiary : theme.colors.primary};
`;

export const $Divider = styled.div`
  width: calc(100% + ${spacing(7)});
  height: ${spacing('px')};
  background: ${({ theme }) => theme.colors.default};
  margin: ${spacing('lg')} calc(-1 * ${spacing('lg')}) ${spacing(5)};
`;
